module.exports = __webpack_public_path__ + "b063540b1a829f0ad52cbb4973de1256.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/ear-muffs-gray.png
// module id = 2179
// module chunks = 0